import $ from 'jquery';

export default function resizeGroup(elements, resizeSelector) {
	// nach Position der Elemente in Gruppen einteilen
	let groups = {};
	$.each(elements, (key, element) => {
		// noinspection JSSuspiciousNameCombination
		const offset = Math.floor(element.offset().top);
		const resizeEl = element.find(resizeSelector);

		// resize element not found, skip this one
		if(resizeEl.length === 0) {
			//TODO gibt es einen sinnvolleren weg zu skippen statt zu returnen?
			return;
		}

		const clone = resizeEl.clone();
		resizeEl.after(clone);

		clone.css('visibility', 'hidden');
		clone.css('position', 'absolute');
		clone.css('top', 0);
		clone.css('left', 0);
		clone.css('min-height', 0);
		// da jQuery width() rundet und das evtl. zu einem Zeilenumbruch führt muss die Breite über diese Methode ermittelt werden
		clone.css('width', resizeEl.get(0).getBoundingClientRect().width);

		const entry = {
			el: resizeEl,
			ref: clone
		};

		Array.isArray(groups[offset]) ? groups[offset].push(entry) : groups[offset] = [entry];
	});

	// jede Höhengruppe:
	// Höhe von größtem Referenzelement auf alle Elemente anwenden
	$.each(groups, (top, elements) => {
		let max = elements.reduce((acc, element) => {
			return Math.max(acc, element.ref.innerHeight())
		}, 0);

		// set max on each element
		$.each(elements, (key, element) => {
			const el = element.el;

			el.css('min-height', max + 'px');
			// el.css('display', 'block');

			element.ref.remove();
		});
	});
}
